var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZoomIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.542,
    height: 30,
    viewBox: "0 0 27.542 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_696",
    "data-name": "Group 696",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M2565.941-1962.477a9.934,9.934,0,0,1-2.105,6.1c-.217.28-.22.437.032.691q4.353,4.409,8.686,8.837a2.492,2.492,0,0,1,.155,3.492,2.513,2.513,0,0,1-3.75-.191q-3.2-4.347-6.375-8.708c-.374-.511-.754-1.018-1.118-1.536a.278.278,0,0,0-.442-.088,9.836,9.836,0,0,1-4.948,1.422,9.552,9.552,0,0,1-4.56-1,9.891,9.891,0,0,1-5.535-7.282,10,10,0,0,1,5.948-11.016,9.732,9.732,0,0,1,10.235,1.406,9.524,9.524,0,0,1,3.724,6.964c.013.151.043.3.053.453S2565.941-1962.628,2565.941-1962.477Zm-10.067-7.905a7.821,7.821,0,0,0-7.872,7.869,7.833,7.833,0,0,0,7.882,7.865,7.866,7.866,0,0,0,7.885-7.835A7.852,7.852,0,0,0,2555.874-1970.382Z",
    transform: "translate(-2545.809 1972.606)",
    fill: "#215c75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M2609.732-1911.444c0,.608.012,1.216,0,1.824-.009.315.109.421.421.418,1.2-.012,2.406.006,3.609-.012.313,0,.391.1.383.393-.016.62-.02,1.241,0,1.861.011.339-.126.439-.447.435-1.14-.013-2.28-.006-3.419-.005-.519,0-.551.024-.54.529.025,1.214-.071,2.43.053,3.643.016.161-.066.2-.2.2-.76,0-1.519,0-2.278-.01-.287,0-.258-.232-.258-.416,0-1.127,0-2.254,0-3.381,0-.562,0-.567-.577-.567-1.115,0-2.229-.01-3.344.005-.365.005-.5-.137-.49-.491.015-.57.015-1.14,0-1.71-.01-.351.108-.495.481-.489,1.165.019,2.331,0,3.5.012.331,0,.445-.1.44-.436-.015-1.165,0-2.33-.011-3.5,0-.357.1-.5.477-.484.619.025,1.241.016,1.861,0,.261-.006.359.077.352.348-.017.607-.005,1.216-.005,1.823Z",
    transform: "translate(-2598.32 1918.103)",
    fill: "#215c75"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn);
export default __webpack_public_path__ + "static/media/zoom-in.c97a7046c764d3ab533588a31e3ffe53.svg";
export { ForwardRef as ReactComponent };